import React from "react";
import { useSelector } from "react-redux";
import SelectedVoiceImage from "./SelectedVoiceImage";
import PlayPreviewButton from "../../../../components/PlayPreviewButton";

const ReceptionistVoiceSelectedSection = ({ isChooseReceptionistOpen, onOpenSelection, onCloseSelection }) => {
  const updatedVoice = useSelector((state) => state.info.updatedVoice);
  const { agentLanguage, voices } = useSelector((state) => state.info);

  if (!voices || voices.length === 0) {
    return null;
  }

  var selectedVoice = voices?.find((voice) => voice.id === updatedVoice);
  if (!selectedVoice && voices.length > 0) {
    selectedVoice = voices[0];
  }

  return (
    <div className="flex md:space-x-8 justify-center items-center">
      <SelectedVoiceImage selectedVoice={selectedVoice} />
      <div className="flex flex-col justify-between">
        <div className="flex flex-col md:flex-row items-start md:items-center gap-2">
          <p className="text-[12px] md:text-[14px] lg:text-[16px]">{selectedVoice.introductionSentence}</p>
          <PlayPreviewButton
            voice={selectedVoice.id}
            textToPlay={selectedVoice.introductionSentence}
            id={"receptionist-preview-button"}
            iconSize="size-7"
            className="flex-row md:flex-col"
            disabled={selectedVoice?.enablePreview === false}
            language={selectedVoice?.language || agentLanguage}
          />
        </div>
        <div className="flex lg:flex-col items-start space-y-2">
          <div className="flex justify-between items-center"></div>
          <button
            onClick={isChooseReceptionistOpen ? onCloseSelection : onOpenSelection}
            className="text-[12px] md:text-[14px] lg:text-[16px] text-primary md:hover:underline"
          >
            Choose other receptionist
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReceptionistVoiceSelectedSection;
